import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { Box } from '@mui/material';
import { useParams } from 'react-router';

interface EditActionsProps {
  isEditMode: boolean;
  onClick: () => void;
  handleCancel: () => void;
  handleSave: () => void;
}

export const EditActions = ({
  isEditMode,
  onClick,
  handleCancel,
  handleSave,
}: EditActionsProps) => {
  return !isEditMode ? (
    <EditOutlinedIcon onClick={onClick} sx={{ alignSelf: 'left' }} />
  ) : (
    <Box sx={{ display: 'flex', gap: '8px' }}>
      <CancelOutlinedIcon
        fontSize="large"
        color="primary"
        onClick={handleCancel}
      />
      <CheckCircleIcon fontSize="large" color="primary" onClick={handleSave} />
    </Box>
  );
};

export const useAdminRouting = () => {
  const { id } = useParams();
  let parsedId: number = null;
  let isNew = false;
  if (id) {
    if (id === 'new') {
      isNew = true;
    } else {
      const intId = parseInt(id);
      if (!isNaN(intId)) {
        parsedId = intId;
      }
    }
  }
  return {
    id: parsedId,
    isNew,
  };
};
